// extracted by mini-css-extract-plugin
module.exports = {"developers-nav":"DevelopersNav_developers-nav__eUMXj","active":"DevelopersNav_active__4S9fw"};